import React, { ReactNode, useState } from 'react';
import styled from 'styled-components';
import { InputText } from 'primereact/inputtext';
import theme from "../../../helpers/theme";
import { EyeIcon } from "primereact/icons/eye";
import { EyeSlashIcon } from "primereact/icons/eyeslash";

type name = string;
type touched = { [key in name]: boolean };
type errors = { [key in name]: string };

export interface IInput {
	icon?: ReactNode;
	inputStyle?: HTMLStyleElement;
	touched?: touched;
	name: name;
	value: string;
	formatValue?: (value: string) => string;
	errors?: errors;
	placeholder: string;
	options?: any;
	label;
	onChange: (name: string, value: string) => void;
}

const defaults = {
	touched: {},
	errors: {},
	value: '',
	onChange: () => {},
	options: {},
};

const TextInput = ({
	                   placeholder,
	                   onChange,
	                   value,
	                   options,
	                   touched,
	                   formatValue,
	                   label,
	                   name,
	                   errors
                   }: IInput & typeof defaults) => {
	const [showPassword, setShowPassword] = useState(false);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		onChange(name, formatValue ? formatValue(e.target.value) : e.target.value);
	};

	const isPassword = placeholder.toLowerCase() === "password";

	return (
		<Container>
			<InputElementContainer>
				<label>{placeholder}</label>
				<StyledTextInput>
					<CustormInputText
						type={isPassword && !showPassword ? "password" : "text"}
						placeholder={"Enter " + placeholder}
						autoComplete={ "off"}
						onChange={handleChange}
						name={name}
						value={value}
						{...options}
					/>
					{isPassword && (
						<ToggleIcon onClick={() => setShowPassword((prev) => !prev)}>
							{showPassword ? <EyeSlashIcon /> : <EyeIcon />}
						</ToggleIcon>
					)}
				</StyledTextInput>
			</InputElementContainer>
			<ErrorMessageContainer>
				<ErrorMessageDisplay>
					{touched[name] && errors[name] ? errors[name] : null}
				</ErrorMessageDisplay>
			</ErrorMessageContainer>
		</Container>
	);
};

TextInput.defaultProps = defaults;

const CustormInputText = styled(InputText)`
  padding: 12px;
  border: none;
  outline: none;
  flex: 1;
	background:#fff!important;
`;

const InputElementContainer = styled.div`
  min-width: 100%;
	text-align: start;
	label{
		font-size:.8rem;
		color:#989898;
	}
  input {
    width: inherit;
    text-transform: capitalize;
  }
  [name="email"], [name="password"], [name="emailOrPhone"] {
    text-transform: none;
  }
`;

const StyledTextInput = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  border-radius: 0.4rem;
  border: 1px solid gray;
  overflow: hidden;
  padding-right: 10px;
`;

const ToggleIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  width: 100%;
`;

const ErrorMessageContainer = styled.div`
  margin-bottom: 10px;
	text-align:start;
`;

const ErrorMessageDisplay = styled.div`
  color: ${theme.error};
  text-transform: capitalize;
  font-size: 12px;
  top: 4px;
  position: relative;
`;

export default TextInput;
